import { gql } from '@apollo/client';

export const GET_EMAIL_LOGS = gql`
  query GetEmailLogs($days: Int) {
    emailLogs(days: $days) {
      id
      to
      from
      subject
      status
      jobId
      error
      sentAt
    }
  }
`;
